import React, { useEffect } from 'react'
import { BrowserRouter, Switch, Route, Router } from 'react-router-dom'
import HooksConfigProvider from '@sisyphe/hooks/es/hooks-config-provider'
import { useDispatch, useSelector, shallowEqual } from 'dva'
import { onApiError } from 'utils/api-error-handler'
import ScrollToTop from 'components/scroll-to-top'
import { Layout } from 'components'
import { History } from 'history'
import Home from './home'
import BookDetail from './detail/book'
import BooartDetail from './detail/booart'
import Search from './search'
import Cart from './cart'
import Mine from './mine'
import Login from './login'
import Settlement from './settlement'
import OrderSuccess from './order-success'

const selector = ({ login }) => ({
  userInfo: login.userInfo,
})
export interface AppProps {
  history: History
}

const App: React.FC<AppProps> = ({ history }) => {
  const dispatch = useDispatch()
  const { userInfo } = useSelector(selector, shallowEqual)

  /**全局查询类目 */
  useEffect(() => {
    userInfo?.token &&
      dispatch({
        type: 'home/echoProductConfig',
        payload: {
          enterpriseCode: '001',
        },
      })
  }, [dispatch, userInfo])

  return (
    <HooksConfigProvider.Provider
      value={{ useRequest: { options: { onError: onApiError(history) } } }}
    >
      <BrowserRouter>
        <Router history={history}>
          <ScrollToTop></ScrollToTop>
          <Switch>
            <Route path="/login">
              <Login />
            </Route>
            <Layout>
              <Route path="/search">
                <Search />
              </Route>
              <Route path="/cart">
                <Cart />
              </Route>
              <Route path="/mine">
                <Mine />
              </Route>
              <Route path="/detail/book" exact>
                <BookDetail />
              </Route>
              <Route path="/detail/booart">
                <BooartDetail />
              </Route>
              <Route path="/settlement">
                <Settlement />
              </Route>
              <Route path="/order-success">
                <OrderSuccess />
              </Route>
              <Route exact path="/">
                <Home />
              </Route>
            </Layout>
          </Switch>
        </Router>
      </BrowserRouter>
    </HooksConfigProvider.Provider>
  )
}

export default App
